export const LOCAL_PATH = '';
export const NON_LOCAL_PATH = window?.appAirDrop?.config?.URL_PREFIX || '/v1/piapi-dev/iesui';

export const envPath = () => (process.env.NODE_ENV === 'development' ? LOCAL_PATH : NON_LOCAL_PATH);

export const generatePath = (path) => `${envPath()}/${path}`;

export const socialLoginErrPathPrefix = (window?.appAirDrop?.config?.LOGIN_URL_PREFIX || '').replace(/login$/, 'iesui');
export const generateSocialErrPath = (path) => `${socialLoginErrPathPrefix}/${path}`;

export const ROUTES = {
  SOCIAL_LOGIN: generateSocialErrPath('socialLoginV2'),
  SOCIAL_LOGIN_CR: generateSocialErrPath('socialLoginV2CR'),
  LOGIN_INTERNAL: generatePath('signin'),
  AUTOLOGIN: generatePath('signin/:autologinEscrow'),
  CREATE_ACCOUNT_INTERNAL: generatePath('signup'),
  CREATE_ACCOUNT_LINK_ACCOUNTS_INTERNAL: generatePath('signup/:escrow'),
  CONSENTS_INTERNAL: generatePath('consents'),
  FORGOT_UN_PW_INTERNAL: generatePath('forgot-unpw'),
  RESET_PW_INTERNAL: generatePath('reset-pw/:escrow'),
  SESSION_ENDED_INTERNAL: generatePath('session-ended'),
  VERIFY_EMAIL_ESCROW_EXPIRED_INTERNAL: generatePath('verify-email-escrow-expired'),
  CHOOSE_ACCOUNT_TYPE_INTERNAL: generatePath('choose-account-type'),
  AUO_WELCOME: generatePath('auo-welcome/:escrow'),
  CREATE_PW: generatePath('create-pw/:escrow'),
  ADD_HOME_COUNTRY: generatePath('add-home-country'),
  ADD_MOBILE_PHONE: generatePath('add-mobile-phone'),
  VERIFY_MOBILE_PHONE_FOR_FORGOT: generatePath('verify-mobile-phone-for-forgot/:escrow'),
  UNVERIFIED_RECAPTCHA: generatePath('unverified-recaptcha'),
  SECURITY_QUESTIONS: generatePath('security-questions/:escrow'),
  SECURITY_QUESTIONS_NO_ESCROW: generatePath('security-questions'),
  VERIFY_MOBILE_PHONE: generatePath('verify-mobile-phone'),
  RESET_PW_LINKS: generatePath('reset-pw-links/:escrowOwnerId/:mobileCode'),
  LINK_ACCOUNTS: generatePath('link-accounts/:escrow'),
  LINK_ACCOUNTS_INTERNAL: generatePath('link-accounts'),
  LINK_ACCOUNTS_ERROR: generatePath('link-accounts-error'),
  LINK_ACCOUNTS_CONFIRMATION: generatePath('link-accounts-confirmation'),
  ACCOUNT_MANAGEMENT_SIGNIN: generatePath('acct'),
  ACCOUNT_MANAGEMENT_MAIN: generatePath('main'),
  VERIFY_MFA_RECAPTCHA: generatePath('verify-mfa-recaptcha'),
  SIGNIN_CODE: generatePath('signin-code'),
  VERIFY_CODE: generatePath('verify-code'),
  CODE_OPTIONS: generatePath('code-options'),
  CODE_HELP: generatePath('code-help'),
};
